import {Injectable} from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { Message } from 'primeng/api';

@Injectable()
export class EndOfDayService extends BaseApiService {

    private wipRollupBalanceData: any;

    // Gets or sets the messages that will be pushed to the p-growl component.
    public growlMessages: Message[] = [];

    // Gets the rollup list data
    public getData(date) {
        return this.get(`Finance/EndOfDay/${date}`);
    }

    // Set a cash drawer as accepted
    public setAccepted(cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/${cashDrawerId}/Status/AcceptedBalanced`, null);
    }

    // Sets a cash drawer as accetped non balanced
    public setAcceptedNonBalanced(cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/${cashDrawerId}/Status/AcceptedNonBalanced`, null);
    }

    // Rollups a business date to the vault
    public rollupCashDrawers(date) {
        return this.post(`Finance/EndOfDay/${date}`, null);
    }

    // Gets the balance data for a cash drawer
    public getBalanceData(cashDrawerId: number) {
        return this.get(`Finance/EndOfDay/Balance/${cashDrawerId}`);
    }

    // Verifies the cash drawer balance data
    public verifyBalance(content: any, cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/Balance/${cashDrawerId}/Verify`, content);
    }

    // Creates a cash adjustment for a cash drawer
    public createCashAdjustment(content: any, cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/Balance/${cashDrawerId}/CashAdjustment`, content);
    }

    // Submits a cash drawer as balanced
    public submitBalance(content: any, cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/Balance/${cashDrawerId}/Status/Balanced`, content);
    }

    // Submits a cash drawer as unbalanced
    public submitUnBalance(content: any, cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/Balance/${cashDrawerId}/Status/Unbalanced`, content);
    }

    // Gets the check details for a given cash drawer
    public getCheckDetails(cashDrawerId: number) {
        return this.get(`Finance/EndOfDay/Balance/${cashDrawerId}/Checks`);
    }

    public resetAndIssueCashDrawer() {
        return this.post('Finance/EndOfDay/RestAndIssueCashDrawerTemporary', null);
    }

    // Closes the third party cash drawer
    public closeThirdPartyCashDrawer(cashDrawerId: number) {
        return this.post(`Finance/EndOfDay/ThirdParty/${cashDrawerId}/Close`, null);
    }
}
